import React, { useEffect, useRef } from "react";
import SeoHelmet from "../components/SeoHelmet";
import Config from "../Config.json";
import { useNavigate, useLocation } from "react-router-dom";

const Contact = () => {
  const form = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  // Nyelv kinyerése az URL-ből pl: /en/contact -> en
  const language = location.pathname.split("/")[1] || "en";

  const sendEmail = async (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);
    const data = {
  name: formData.get("vezeteknev") + " " + formData.get("keresztnev"),
  email: formData.get("email"),
  message: formData.get("comment"),
  language: "en", // <<< Itt beállítjuk
};


    try {
      const response = await fetch(`${Config.API_BASE_URL}/contact`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
      });


      const result = await response.json();

      if (result.success) {
        alert("Message successfully sent!");
        e.target.reset();
      } else {
        alert("Error: " + result.message);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("An error occurred while sending the message.");
    }
  };

  useEffect(() => {
    const mybutton = document.getElementById("TopBtn");
    const scrollFunction = () => {
      if (window.scrollY > 100) mybutton.style.display = "block";
      else mybutton.style.display = "none";
    };
    const topFunction = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    window.addEventListener("scroll", scrollFunction);
    mybutton.addEventListener("click", topFunction);

    return () => {
      window.removeEventListener("scroll", scrollFunction);
      mybutton.removeEventListener("click", topFunction);
    };
  }, []);

  return (
    <main className="contact-main-content">
      <SeoHelmet
        title={`${Config.SITE_TITLE} | Contact`}
        description="Get in touch with us to share what AI topics you'd like to explore, AI tools, applications and insights."
        keywords={["AI", "Contact", "AI tools", "AI applications", "GPT-4", "Machine Learning"]}
        url={`${Config.SITE_DOMAIN}/${language}/Contact`}
        image="/images/og-contact.jpg"
        lang={language}
        author="Zsolt Fenyő"
      />
      
      <button id="TopBtn" title="Go to top">&#10224;</button>
      <div className="w-100">
        <div className="contact-container">
          <h1 className="contact py-3 ps-3">Contact us</h1>
        </div>
        <div className="contact-content-container w-75">
          <p className="contact-margin-y1">
            Get in touch with us to share what AI topics you'd like to explore! Let us know if there’s a particular AI tool, aspect, or application you're curious about, or if there's any other topic where we can provide insights and support.
          </p>

          <form ref={form} onSubmit={sendEmail} className="contact-margin-y contact-color">
            <div className="mt-4 mb-4">
              <label>Firstname <span>*</span></label>
              <input type="text" className="form-control" name="vezeteknev" placeholder="Firstname" required />
            </div>
            <div className="mt-4 mb-4">
              <label>Surname <span>*</span></label>
              <input type="text" className="form-control" name="keresztnev" placeholder="Surname" required />
            </div>
            <div className="mt-4 mb-4">
              <label>Email address <span>*</span></label>
              <input type="email" className="form-control" name="email" placeholder="Enter email" required />
            </div>
            <div className="form-group">
              <label>Comment: <span>*</span></label>
              <textarea className="form-control" rows="5" name="comment" required></textarea>
            </div>
            <div className="mt-4 mb-4 form-check">
              <input type="checkbox" className="form-check-input" required />
              <label className="form-check-label">
                I agree that my personal data will be processed for business purposes until consent is withdrawn.
              </label>
            </div>
            <button type="submit" className="btn btn-Bosch-primary">Send</button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default Contact;
